import { useEffect, useRef, useState } from 'react';
import { request } from '../lib/api';
interface QueueRow { id: string; name: string; status: string; processed: string; total: string; createdAt: string; updatedAt: string; error: string | null }
interface Queue { queued: number; failed: number; oldestQueuedAt: string | null; rows: QueueRow[] }
export function EnrichmentQueue({ onOpen }: { onOpen: (id: string) => void }) {
  const [data, setData] = useState<Queue | null>(null);
  const [error, setError] = useState('');
  const [rate, setRate] = useState<number | null>(null);
  const previous = useRef<{ at: number; rows: QueueRow[] } | undefined>(undefined);
  useEffect(() => {
    let cancelled = false, pending = false;
    const refresh = async () => {
      if (pending || document.hidden) return;
      pending = true;
      try {
        const next = await request<Queue>('/api/jobs/enrichment-queue');
        if (cancelled) return;
        const at = Date.now(), old = previous.current;
        if (old) {
          const delta = next.rows.reduce((sum, row) => {
            const before = old.rows.find(r => r.id === row.id);
            return sum + (before ? Math.max(0, Number(row.processed) - Number(before.processed)) : 0);
          }, 0);
          setRate(Math.round(delta * 3600000 / Math.max(1, at - old.at)));
        }
        previous.current = { at, rows: next.rows }; setData(next); setError('');
      } catch { if (!cancelled) setError('Queue status unavailable.'); }
      finally { pending = false; }
    };
    void refresh(); const timer = setInterval(() => void refresh(), 30000);
    return () => { cancelled = true; clearInterval(timer); };
  }, []);
  return <section className="operation-panel" aria-label="Queue health"><h2>Queue health</h2>
    {error && <p role="alert">{error}</p>}
    <div className="lead-command-strip"><span>Waiting: {data?.queued ?? '—'}</span><span>Failed jobs: {data?.failed ?? '—'}</span><span>Observed processing rate: {rate === null ? 'Measuring' : `${rate.toLocaleString()}/hour`}</span><span>Oldest queued: {data?.oldestQueuedAt ? new Date(data.oldestQueuedAt).toLocaleString() : '—'}</span></div>
    <div style={{ maxHeight: 300, overflow: 'auto' }}><table><thead><tr><th>Job</th><th>State</th><th>Processed</th><th>Last progress</th><th>Error</th></tr></thead><tbody>{data?.rows.map(row => <tr key={row.id}><td><button type="button" onClick={() => onOpen(row.id)}>{row.name}</button></td><td>{row.status}</td><td>{Number(row.processed).toLocaleString()} / {Number(row.total).toLocaleString()}</td><td>{new Date(row.updatedAt).toLocaleString()}</td><td>{row.error ?? '—'}</td></tr>)}</tbody></table></div>
  </section>;
}
